const STATUS: Record<string, { label: string; className: string }> = {
  draft: { label: 'Draft', className: 'bg-slate-100 text-slate-700' },
  test_sent: { label: 'Test sent', className: 'bg-sky-100 text-sky-800' },
  scheduled: { label: 'Scheduled', className: 'bg-amber-100 text-amber-900' },
  sending: { label: 'Sending', className: 'bg-indigo-100 text-indigo-800' },
  sent: { label: 'Sent', className: 'bg-emerald-100 text-emerald-800' },
  canceled: { label: 'Canceled', className: 'bg-slate-100 text-slate-600' },
  failed: { label: 'Failed', className: 'bg-red-100 text-red-800' },
};

export function CampaignStatus({ status }: { status: string }) {
  const badge = STATUS[status] ?? {
    label: status.replaceAll('_', ' '),
    className: 'bg-slate-100 text-slate-700',
  };
  return (
    <span className={`inline-flex rounded-full px-3 py-1 text-sm font-medium ${badge.className}`}>
      {badge.label}
    </span>
  );
}
